const numOrDefault = (v, d)=>typeof v === 'number' && !isNaN(v) ? v : d
;
const getCalculatedMaximumQuantity = (maximumQuantity, availableQuantity)=>{
    const max = numOrDefault(maximumQuantity, Infinity);
    return Math.min(max, numOrDefault(availableQuantity, max));
};

export { getCalculatedMaximumQuantity };
//# sourceMappingURL=get-calculated-maximum-quantity.js.map
